import React from 'react';
import CRPBlockWrapper from './CRPBlockWrapper';

const BLOCK_TITLE = "Why?";

export default function CRPWhyBlock({ why }) {
  return (
    <CRPBlockWrapper title={BLOCK_TITLE}>
      <div className='standardBlock'>
        <div className='description'>{why}</div>
      </div>
    </CRPBlockWrapper>
  )
}